import OpticksSpinner from "@/components/ui/OpticksSpinner/OpticksSpinner";
import "./LoadingView.css";

interface LoadingViewProps {
  variation?: string;
}

const LoadingView = ({ variation = "grey" }: LoadingViewProps) => (
  <div className="layout-center loading-view">
    <OpticksSpinner variation={variation} />
  </div>
);

export default LoadingView;
